
//#region Imports
//#region Angular
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

//#endregion

//#region Bootstrap
import {
    ModalModule,
    PopoverModule,
    TabsModule,
    TooltipModule,
    BsDropdownModule,
    BsModalRef
} from 'ngx-bootstrap';
import {
    BsDatepickerModule,
    BsDatepickerConfig,
    BsDaterangepickerConfig,
    BsLocaleService
} from 'ngx-bootstrap/datepicker';

import { NgxBootstrapDatePickerConfigService } from '../../../../assets/ngx-bootstrap/ngx-bootstrap-datepicker-config.service';

//#endregion

//#region Primeng
import { TableModule } from 'primeng/table';
import {
    TreeModule,
    DragDropModule,
    EditorModule,
    InputMaskModule,
    AutoCompleteModule,
    ProgressSpinnerModule,
    ContextMenuModule,
    ButtonModule,
    PaginatorModule,
    CalendarModule,
    CheckboxModule,
    SelectButtonModule,
    InputSwitchModule,
    CarouselModule
} from 'primeng';
import { DropdownModule } from 'primeng/dropdown';
//#endregion


//#region Custom

//#region Modules
import { UtilsModule } from "../../../../shared/utils/utils.module";
import { UblCommonModule } from "./common/common.module";

//#endregion


//#region Services
import { TypeHelperService } from './services/type-helper.service';
import { CountryHelperService } from "./services/country-helper.service";

//#endregion

//#endregion

//#endregion

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        ModalModule.forRoot(),

        ModalModule.forRoot(),
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        BsDropdownModule.forRoot(),
        BsDatepickerModule.forRoot(),

        TableModule,
        UtilsModule,
        DropdownModule,
        ButtonModule,
        PaginatorModule,
        AutoCompleteModule,
        ProgressSpinnerModule,

        UblCommonModule
    ],
    declarations: [
    ],
    exports: [
    ],
    entryComponents: [
    ],
    providers: [
        TypeHelperService,
        CountryHelperService,

        BsModalRef,
        { provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig },
        { provide: BsDaterangepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDaterangepickerConfig },
        { provide: BsLocaleService, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerLocale }
    ],
})
export class ShopSystemModule { }
